import { gql } from "@apollo/client";

export const CREATE_ADICIONAL_EVALUACION = gql`
    mutation CreateEvaluacionAdicionales($input: AddAdicionalEvaluacionInput!, $idEvaluacion: Int!)
    {
        createEvaluacionAdicionales(input: $input, idEvaluacion: $idEvaluacion) 
        {
            idEvaluacionAd
            idEvaluacion
        }
    }
`;